<script>
  import options from './DanmarksKortMap.options'
  export default options
</script>

<template>
  <div ref="rootRef" class="kb-danmarks-kort-map" :class="{ 'kb-danmarks-kort-map--sundhedsraad': mapLevel === 'sundhedsraad' }" :style="paletteStyle">
    <div v-if="isLoading" class="kb-spinner-overlay" aria-hidden="true">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>

    <button
      v-if="breadcrumb.length"
      type="button"
      class="kb-danmarks-kort-map__back"
      @click="goBack"
    >
      <span class="kb-danmarks-kort-map__back-icon" aria-hidden="true"></span>
      <span class="kb-danmarks-kort-map__back-label">{{ breadcrumb[breadcrumb.length - 1].label }}</span>
    </button>

    <div
      ref="wrapperRef"
      class="kb-danmarks-kort-map__svg-wrapper"
      aria-hidden="true"
      v-html="svgContent"
      @mouseover="onMouseover"
      @mousemove="onMousemove"
      @mouseleave="onMouseleave"
      @click="onMapClick"
    />

    <template v-if="markers.length">
      <button
        v-for="marker in markers"
        :key="marker.key"
        type="button"
        class="kb-danmarks-kort-map__marker"
        :data-marker-key="marker.key"
        :style="{ left: marker.x + 'px', top: marker.y + 'px' }"
        :aria-label="'Vælg ' + marker.key"
        @click.stop="selectGroup(marker.key)"
        @mouseleave="onMarkerMouseleave"
        @focus="hoveredMarkerKey = marker.key; setHover(marker.attr, marker.key)"
        @blur="hoveredMarkerKey = null; clearHover()"
      >
        <span class="kb-ui-icon kb-ui-icon--ui-plus-bold kb-danmarks-kort-map__marker-icon" aria-hidden="true"></span>
        <span v-if="hoveredMarkerKey === marker.key" class="kb-danmarks-kort-map__marker-label">
          {{ marker.key }}
        </span>
      </button>
    </template>

    <ul
      v-if="mapLevel === 'region'"
      ref="regionListRef"
      class="kb-danmarks-kort-map__accessibility-list"
      :aria-label="regionListLabel"
    >
      <li v-for="(g, gIndex) in activeRegionGroups" :key="g">
        <button
          type="button"
          :tabindex="regionListTabIndexes[gIndex]"
          @click="selectRegionGroup(g)"
          @focus="onRegionListItemFocus(gIndex, g)"
          @blur="onRegionListItemBlur"
          @keydown="onRegionListKeydown($event, gIndex)"
        >{{ formatEntityLabel(g) }}</button>
      </li>
    </ul>

    <ul class="kb-danmarks-kort-map__legend" :aria-label="legendLabel">
      <li
        v-for="item in legendEntries"
        :key="item.slot + '-' + item.value"
        class="kb-danmarks-kort-map__legend-item"
      >
        <span
          class="kb-danmarks-kort-map__legend-swatch"
          :style="{ backgroundColor: 'var(--kb-dk-value-' + item.slot + ')' }"
          aria-hidden="true"
        />
        <span class="kb-danmarks-kort-map__legend-label">{{ item.label }}</span>
      </li>
    </ul>

    <Teleport to="body">
      <div
        v-if="tooltip.visible"
        class="kb-dk-tooltip"
        :style="{ left: tooltip.x + 12 + 'px', top: tooltip.y + 12 + 'px' }"
        aria-hidden="true"
      >{{ tooltip.name }}</div>
    </Teleport>
  </div>
</template>
